/*
 * Easing Functions, gratefully stolen from https://gist.github.com/gre/1650294
 */

/**
 * No easing, no acceleration.
 *
 * @param t time, value between 0 and 1.
 */
export const linear = (t: number): number => t;

/**
 * Accelerating from zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInQuad = (t: number): number => t * t;

/**
 * Decelerating to zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeOutQuad = (t: number): number => t * (2 - t);

/**
 * Acceleration until halfway, then deceleration.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInOutQuad = (t: number): number =>
  t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

/**
 * Accelerating from zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInCubic = (t: number): number => t * t * t;

/**
 * Decelerating to zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeOutCubic = (t: number): number => --t * t * t + 1;

/**
 * Acceleration until halfway, then deceleration.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInOutCubic = (t: number): number =>
  t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;

/**
 * Accelerating from zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInQuart = (t: number): number => t * t * t * t;

/**
 * Decelerating to zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeOutQuart = (t: number): number => 1 - --t * t * t * t;

/**
 * Acceleration until halfway, then deceleration.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInOutQuart = (t: number): number =>
  t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;

/**
 * Accelerating from zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInQuint = (t: number): number => t * t * t * t * t;

/**
 * Decelerating to zero velocity.
 *
 * @param t time, value between 0 and 1.
 */
export const easeOutQuint = (t: number): number => 1 + --t * t * t * t * t;

/**
 * Acceleration until halfway, then deceleration.
 *
 * @param t time, value between 0 and 1.
 */
export const easeInOutQuint = (t: number): number =>
  t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
